export default class NavMobile {

  constructor() {
    this.html = document.querySelector('html');
    this.body = document.querySelector('body');
    this.header = document.querySelector('.header');
    this.nav = document.querySelector('.navigation--header')
    this.triggerButton = document.querySelector('.navigation--trigger');
    this.triggers = document.querySelectorAll('.navigation--trigger-overlay, .navigation--trigger');
    this.active = false;

    if (this.nav && this.triggers) {
      this.header.addEventListener('click', (event) => {
        if (this.active) {
          setTimeout(() => {
            this.html.classList.remove('overflow-hidden');
            this.header.classList.remove('navigation__active');
            this.nav.classList.replace('opacity-100', 'opacity-0');
            this.nav.classList.replace('visible', 'invisible');
          }, 300);
          this.active = false;
        }
        else {
          let triggerHit = false
          this.triggers.forEach((trigger, key) => {
            if (event.target == trigger) {
              triggerHit = true;
            }
          });

          if (triggerHit) {
            this.active = true;
            this.html.classList.add('overflow-hidden');
            this.header.classList.add('navigation__active');
            this.nav.classList.replace('opacity-0', 'opacity-100');
            this.nav.classList.replace('invisible', 'visible');
          }
        }

        this.triggerButton.setAttribute('aria-pressed', this.active);
        this.triggerButton.setAttribute('aria-label', this.active ? 'Navigation ausblenden' : 'Navigation einblenden');
        this.nav.setAttribute('aria-hidden', !this.active);
      });

    }
  }

}
